exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".prompt[data-v-c2fd0d6e] {\n  padding: 1em 0 2em;\n}\n.address[data-v-c2fd0d6e] {\n  padding-bottom: 2em;\n}\n", ""]);

// exports
